import { render, staticRenderFns } from "./changeTheme.vue?vue&type=template&id=2f735350&scoped=true"
import script from "./changeTheme.vue?vue&type=script&setup=true&lang=js"
export * from "./changeTheme.vue?vue&type=script&setup=true&lang=js"
import style0 from "./changeTheme.vue?vue&type=style&index=0&id=2f735350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_css-loader@6.11.0_webpack@5.109.2_cssnano@5.1.15__txhfkviks3ummxta33hlcz7ciy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f735350",
  null
  
)

export default component.exports